import React from 'react'
import { Link } from 'react-router-dom';
function ProductsDetailsSection6() {
  return (
    <>
      <div className="container-fluid px-5 bgg-col backSection14 py-5 backcolor1">
        {/* Heading Row */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">More Items</h3>
          <p className="text-dark mb-0 ">
          {/* <span className="d-flex justify-content-between align-items-center gap-1 ">View All<i className="bi bi-chevron-right viewAll"></i></span> */}

          </p>
          
        </div>

        {/* Product Cards */}
        

        <div className="row g-4 pb-5">
        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Oxygen_Bubble.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Dynamic Oxygen Bubble <br></br>Device</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹110</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Retinol.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Retinol Facial Serum Antiaging Serum </h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹110</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Beauty3.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Beauty 3 in 1 Oxygeneo Facial Machine </h6>
              <small className="mb-0"></small>
             <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹18999</p>
              <small className="text-decoration-line-through text-muted ">$24500</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
           
            <div className="position-relative d-inline-block">
            <img src="/Images/Carbon_gel.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1  fw-bold">Carbon gel carbon laser pigmentation 80 ml </h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹299</p>
              <small className="text-decoration-line-through text-muted ">$449</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-4 pb-5">
        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Mat_Rehna.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Mat Rehna School Ke Bharose | Hindi Book</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹145</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/3D_Derma.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold ">3D Derma Roller | Skin Tightening Roller</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹180</p>
              <small className="text-decoration-line-through text-muted ">$200</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Frankly_Mole.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Frankly Mole Removal Watt Removal Pen</h6>
              <small className="mb-0"></small>
             <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹1149</p>
              <small className="text-decoration-line-through text-muted ">$1500</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
           
            <div className="position-relative d-inline-block">
            <img src="/Images/Bamboo_Therapy.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Bamboo Therapy Cup | Large Size | Wooden Cup</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹150</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-4 pb-5">
        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Memory_Pillow.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Memory Pillow | Relaxation | Sleep</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹549</p>
              <small className="text-decoration-line-through text-muted ">$899</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
             <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
        {/* new add */}
         <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/DigitalDerma1.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Digital Dermamicroscope | Skin Anatomy...</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹1299</p>
              <small className="text-decoration-line-through text-muted ">$1500</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
             <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
         <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Thearapist.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Powerful 32 Speed Body Massage Gun Facial Gun Deep...</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹549</p>
              <small className="text-decoration-line-through text-muted ">$899</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
             <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
         <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Butterfly1.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Mini Accupressure massager | Butterfly Massager</h6>
              <small className="mb-0"></small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹549</p>
              <small className="text-decoration-line-through text-muted ">$899</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
             <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
        </div>
      </div>
      
    </>
  )
}

export default ProductsDetailsSection6;
